import React, { useState } from 'react';
import { GlassCard } from './GlassCard';
import { GlassInput } from './GlassInput';
import { GlassButton } from './GlassButton';
interface DailyInputFormProps {
  onSubmit: (amount: number) => void;
}
export function DailyInputForm({
  onSubmit
}: DailyInputFormProps) {
  const [amount, setAmount] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const value = parseFloat(amount) || 0;
    if (value > 0) {
      onSubmit(value);
      setAmount('');
    }
  };
  return <GlassCard className="p-6" data-id="element-32">
      <h3 className="text-xl font-semibold text-white mb-4" data-id="element-33">
        Add Contribution
      </h3>
      <form onSubmit={handleSubmit} className="space-y-4" data-id="element-34">
        <GlassInput type="number" placeholder="0.00" value={amount} onChange={setAmount} min={0} step={0.01} data-id="element-35" />
        <GlassButton type="submit" variant="primary" className="w-full" data-id="element-36">
          Add Payment
        </GlassButton>
      </form>
    </GlassCard>;
}